import styled from 'styled-components'
import { mediaqueries } from '~/utils/mediaqueries'
import { GreatPrimer, Brevier } from '~/components/Typography'

export const Label = styled(GreatPrimer)`
  flex: 0 0 100%;
  margin-bottom: ${({ theme: { toRem } }) => toRem(5)};
`
const InputStyles = ({ theme: { color, toRem } }) => `
    border: none;
    outline: none;
    flex: 0 0 100%;
    appearance: none;

    height: ${toRem(55)};
    background: ${color('accent', 80)};
    padding: 0 ${toRem(20)};
    font-size: ${toRem(13)};
    font-family: inherit;
    ::placeholder {
      color: ${color('accent')};
    }
`

export const Input = styled.input`
  ${InputStyles};
`

export const Textarea = styled.input`
  ${InputStyles};
  resize: none;
  background: ${({ theme: { color } }) => color('light')};
  padding: ${({ theme: { toRem } }) => toRem(15)};
  height: ${({ theme: { toRem } }) => toRem(50)};
  border-radius: 4px;
  border: solid 1px ${({ theme }) => theme.color('accent', 90)};
  margin-bottom: 25px;

  ${props => props.help && `margin-bottom: 0;`}

  @media ${mediaqueries.md} {
    margin-top: 0;
  }
`

export const Wrapper = styled.div`
  flex: 0 0 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: -10px;

  ${({ border, theme }) =>
    border && `border-bottom: 1px solid ${theme.color('accent', 80)};`}
`

export const CharacterCounter = styled(Brevier)`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  font-size: 100%;
  font-weight: 600;
  padding-top: 0.5rem;
`

export const HelpText = styled(Brevier)`
  display: flex;
  justify-content: flex-start;
  width: 80%;
  font-size: 75%;
  font-weight: 600;
  padding-top: 0.5rem;
`
